import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog']

  connect() {
    document.addEventListener('keydown', this.handleEscape.bind(this))
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscape.bind(this))
  }

  open() {
    this.dialogTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  close() {
    this.dialogTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
